import styled from 'styled-components';

export const ScVerticalCarouselPreviewWrapper = styled.div`
  position: relative;
  height: inherit;
`;
